export const composerStyles = {
  root: "shrink-0 px-3 pb-composer-bottom pt-2",
  card: "rounded-2xl border border-border bg-card shadow-md transition-all focus-within:ring-2 focus-within:ring-active",
  inner: "flex items-end gap-2 px-4 py-3.5",
  input:
    "min-h-6 flex-1 resize-none overflow-y-auto bg-transparent py-0.5 text-sm leading-relaxed text-secondary-foreground outline-none placeholder:text-subtle",
  sendBtn:
    "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-white shadow-sm transition-all hover:bg-primary-dark disabled:cursor-default disabled:bg-border disabled:text-subtle disabled:shadow-none disabled:hover:bg-border",
  cancelBtn:
    "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-muted text-mid transition-colors hover:bg-dim",
};
